import { render, staticRenderFns } from "./work-order-per-item-row.vue?vue&type=template&id=6deff3ab&"
import script from "./work-order-per-item-row.vue?vue&type=script&lang=js&"
export * from "./work-order-per-item-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports